import { z } from "zod";

export const perCompanyQuerySchema = z.object({
  company: z.uuid(),
});

export type PerCompanyQuery = z.infer<typeof perCompanyQuerySchema>;
